import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFinder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFinder"><Path d="M13.5 13.5H11.375C11.5604 10.3095 11.8897 6.81677 12.6657 3.73583M7.5 8.5V10.5M16.5 8.5V10.5M7.5 15.5C11 18 13 18 16.5 15.5M20.5 3.5V20.5H3.5V3.5H20.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFinder;
